import { render, staticRenderFns } from "./Delays.vue?vue&type=template&id=852eeec4&"
import script from "./Delays.vue?vue&type=script&lang=js&"
export * from "./Delays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports